import { useEffect, useState, useMemo } from 'react';
import Button from '../../../../button/button.jsx';
import Modal from '../../../../modal/modal.jsx'; // Asegúrate de importar el componente Modal
import './PauseDropStudentCalendar.scss';
import InputDate from '../../../../inputDate/inputDate.jsx';
import InputAnimated from '../../../../inputAnimated/inputAnimated.jsx';
import { formatToLocalDate } from '../../../../../utils/dateTimeZone.js';
import { PostPauseStudentPayment, PostWithdrawStudent } from '../../../../../utils/Apis/apis.jsx';
import { PostDefinitiveWithdrawStudent } from '../../../../../utils/Apis/receptionApis.jsx';
const PauseDropStudentCalendar = ({ isOpen, setOpen, disabled, student_id, selectedGroup, refreshClassData, showAlert, action, handleCloseDropStudentFromGroup }) => {
    const [dateSelected, setDateSelected] = useState({})
    const [resetKey, setResetKey] = useState(false);
    const [checkedPause, setCheckedPause] = useState(false);


    useEffect(() => {
        if (isOpen) {
            if (action === 'pause') {
                setCheckedPause(true)
            }else{
                setCheckedPause(false)
            }
            setDateSelected({})
        }
    }, [isOpen])
    const handleDateSelected = async (date) => {
        const detect = await detectDateType(date, 'withdraw', 'pause')
        setDateSelected(detect)
    }
    function normalizeDateString(dateStr) {
        if (typeof dateStr !== 'string') return dateStr;

        if (dateStr.includes('/')) {
            const [day, month, year] = dateStr.split('/').map(Number);

            if (!day || !month || !year) return null;

            // 🔥 regresar objeto Date LOCAL (clave)
            return new Date(year, month - 1, day);
        }

        return dateStr;
    }
    async function detectDateType(input, dayType, rangeType) {
        // Caso Date
        if (input instanceof Date && !isNaN(input.getTime())) {
            return {
                type: dayType,
                start_date: formatToLocalDate(input),
                end_date: ''
            };
        }

        if (typeof input === 'string') {
            // Normalizar separadores raros
            const normalized = input.replace(/–|—/g, '-');

            const parts = normalized.split('-').map(s => s.trim());

            if (parts.length === 2) {
                let [startStr, endStr] = parts;

                // 🔥 NORMALIZAR AQUÍ
                startStr = normalizeDateString(startStr);
                endStr = normalizeDateString(endStr);

                return {
                    type: rangeType,
                    start_date: formatToLocalDate(startStr),
                    end_date: formatToLocalDate(endStr)
                };
            }
        }

        return { type: 'unknown' };
    }
    
    const handleCancel = () => {
        setOpen(!isOpen)
    }

    const handleDropPauseStudent = async () => {
        if (Object.keys(dateSelected).length !== 0) {
            if (dateSelected.type === 'withdraw') {
                if (action === 'wd') {
                    const postWithdrawStudent = await PostWithdrawStudent(student_id, selectedGroup, dateSelected)
                    let status = postWithdrawStudent.status
                    if (status === 200) {
                        showAlert('success', postWithdrawStudent.message)
                        refreshClassData()
                        handleCloseDropStudentFromGroup()
                        handleCancel()
                    }
                } else if (action === 'dropOut') {
                    const postGeneralWithdrawStudent = await PostDefinitiveWithdrawStudent(student_id, dateSelected)
                    let status = postGeneralWithdrawStudent.status
                    if (status === 200) {
                        showAlert('success', postGeneralWithdrawStudent.message)
                        refreshClassData()
                        setTimeout(() => {
                            window.location.reload()
                        }, 2000)
                    } else {
                        showAlert('danger', postGeneralWithdrawStudent.message)
                    }
                }

            } else if (dateSelected.type === 'pause') {
                if (action === 'pause') {
                    const postPauseStudentPaymentResponse = await PostPauseStudentPayment(student_id, dateSelected)
                    let status = postPauseStudentPaymentResponse.status
                    if (status === 200) {
                        showAlert('success', postPauseStudentPaymentResponse.message)
                        refreshClassData()
                        handleCloseDropStudentFromGroup()
                        handleCancel()
                    }
                }
            } else {
                showAlert('danger', 'Asegurate de tener seleccionada la fecha')
            }
        } else {
            showAlert('danger', 'Asegurate de tener seleccionada la fecha')
        }


    }
    return (
        <Modal isOpen={isOpen} overlayClick={false}>
            <div className="modal-alert">
                <div className="alert-header">
                    {!checkedPause ?
                        <h2>Seleccione la fecha de baja</h2>
                        :
                        <h2>Seleccione el rango de fechas</h2>
                    }
                </div>
                <div className='date-picker-container'>
                    {!checkedPause ?
                        <InputDate selectionType={'date'} placeholder='Selecciona fecha de baja' onChange={(date) => handleDateSelected(date)} resetKey={resetKey} />
                        :
                        <>
                            <InputDate selectionType={'week-range'} placeholder='Selecciona rango de la pausa' onChange={(date) => handleDateSelected(date)} resetKey={resetKey} />

                        </>

                    }
                </div>
                <div className="alert-buttons">
                    <Button onClick={handleCancel} text={'Cancelar'} disabled={disabled}></Button>
                    <Button onClick={handleDropPauseStudent} text={'Aceptar'} disabled={disabled}></Button>
                </div>
            </div>
        </Modal>
    );
};

export default PauseDropStudentCalendar;
